import $ from 'jquery';

/**
 * if input placeholders are supported, the label of a form field is converted to a placeholder attribute
 */
$.fn.extend({
    labelToPlaceholder: function () {
        return this.each((index, element) => {
            const input = $(element);
            const label = input.closest('form').find(`label[for="${input.attr('id')}"]`);

            input.attr('placeholder', label.text());
            input.placeholder();
        });
    }
});


// WEBPACK FOOTER //
// ./jquery/jquery.labelToPlaceholder.js